import React, { useState, useEffect } from 'react';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { sortBy } from 'lodash';

import AddCustomGHGCollectionModal from '../../../modals/AddCustomGHGCollectionModal';
import CloneCustomGHGCollectionModal from '../../../modals/CloneCustomGHGCollectionModal';
import CustomGHGCollection from './CustomGHGCollection';

export default function CustomGHGCollections(props) {
  const {
    organization,
    showToast,
    createAccess,
    updateAccess,
    deleteAccess,
    GHGConversions,
    GHGCollections,
    addToList,
    updateList,
    removeFromList,
  } = props;

  const [showAddModal, setShowAddModal] = useState(false);
  const [showCloneModal, setShowCloneModal] = useState(false);

  const [activeCollectionId, setActiveCollectionId] = useState(null);
  const [activeCollection, setActiveCollection] = useState(null);

  const resetCollection = () => {
    setActiveCollectionId(null);
  };

  useEffect(() => {
    if (activeCollectionId !== null) {
      setActiveCollection(
        GHGCollections.find(
          (collection) => collection.id === activeCollectionId
        )
      );
    } else {
      setActiveCollection(null);
    }
  }, [GHGCollections, activeCollectionId]);

  return (
    <>
      <Row style={{ margin: 0 }}>
        <Col style={{ display: 'inline-flex' }}>
          <Row>
            <Form inline style={{ marginBottom: '0.5em' }}>
              <Form.Label
                style={{
                  display: 'block',
                  marginRight: '0.5em',
                  marginLeft: '0.5em',
                }}
              >
                GHG Collection:
              </Form.Label>
              <Form.Control
                style={{ float: 'right' }}
                as='select'
                size='sm'
                value={activeCollectionId ? activeCollectionId : ''}
                onChange={(e) => {
                  let cid = e.target.value;
                  setActiveCollectionId(parseInt(cid));
                }}
              >
                <option hidden value={'null'} key={'null-opt'}>
                  Select a Collection
                </option>
                {GHGCollections.length === 0 && (
                  <option disabled value={'null'} key={'null-null'}>
                    No Collections
                  </option>
                )}
                {sortBy(GHGCollections, ['name']).map((collection) => (
                  <option
                    key={`collection-opt-${collection.id}`}
                    value={collection.id}
                  >
                    {collection.name}
                  </option>
                ))}
              </Form.Control>
            </Form>
          </Row>
          <Row style={{ marginLeft: '20px' }}>
            {createAccess && (
              <Button
                onClick={() => {
                  setShowAddModal(true);
                }}
                style={{ marginBottom: '1em', float: 'right' }}
              >
                Add GHG Collection
              </Button>
            )}
            {createAccess && (
              <Button
                onClick={() => {
                  setShowCloneModal(true);
                }}
                style={{
                  marginBottom: '1em',
                  marginLeft: '1em',
                  float: 'right',
                }}
              >
                Clone GHG Collection
              </Button>
            )}
          </Row>
        </Col>
      </Row>

      {activeCollectionId !== null && activeCollection && (
        <CustomGHGCollection
          showToast={showToast}
          organization={organization}
          updateAccess={updateAccess}
          deleteAccess={deleteAccess}
          GHGConversions={GHGConversions}
          collection={activeCollection}
          addToList={addToList}
          updateList={updateList}
          removeFromList={removeFromList}
          resetCollection={resetCollection}
        />
      )}
      <AddCustomGHGCollectionModal
        show={showAddModal}
        onHide={() => {
          setShowAddModal(false);
        }}
        showToast={showToast}
        organization_id={organization.id}
        addToList={addToList}
        setActiveCollectionId={setActiveCollectionId}
      />
      <CloneCustomGHGCollectionModal
        show={showCloneModal}
        onHide={() => {
          setShowCloneModal(false);
        }}
        showToast={showToast}
        organization_id={organization.id}
        GHGCollections={GHGCollections}
        setActiveCollectionId={setActiveCollectionId}
        addToList={addToList}
        updateList={updateList}
      />
    </>
  );
}
